"use strict";
var config = require("app/util/config/config");

var MetricType = React.createClass({
  statics: {
    getIconClass: function (type){
      var map = {
        "VISITA": "visit",
        "LIGACAO": "call",
        "EMAIL": "email",
        "PROPOSTA": "proposal",
        "REUNIAO": "meeting",
        "WHATSAPP": "whatsapp"
      };
      return map[type] || null;
    },
    getImageUrl: function (type, tag){
      var map = {
        "VISITA": config.app.webAppURL + `/images/pin${tag}.svg`,
        "LIGACAO": config.app.webAppURL + `/images/phone${tag}.svg`,
        "EMAIL": config.app.webAppURL + `/images/email${tag}.svg`,
        "PROPOSTA": config.app.webAppURL + `/images/document${tag}.svg`,
        "REUNIAO": config.app.webAppURL + `/images/meeting${tag}.svg`,
        "WHATSAPP": config.app.webAppURL + `/images/whatsapp${tag}.svg`
      };
      return map[type] || null;
    },
    getLabel: function (type, done, doneBy){
      var map = {
        "VISITA": (done) ? "Visita realizada" : "Visitar",
        "LIGACAO": (done) ? "Ligação feita" : "Ligar",
        "EMAIL": (done) ? ((doneBy == "User" || !doneBy) ? "Email enviado" : "Email recebido") : "Enviar email",
        "PROPOSTA": (done) ? "Proposta enviada" : "Enviar proposta",
        "REUNIAO": (done) ? "Reunião realizada" : "Participar de reunião",
        "WHATSAPP": (done) ? "WhatsApp enviado" : "Enviar WhatsApp"
      };
      return map[type] || null;
    }
  },
  render: function render(){
    return null;
  }
});

module.exports = MetricType;



// WEBPACK FOOTER //
// ./app/screens/Activity/components/Metric/metric-type.jsx